import { render, staticRenderFns } from "./MenuBtn.vue?vue&type=template&id=12c0ca8a&scoped=true"
import script from "./MenuBtn.vue?vue&type=script&lang=js"
export * from "./MenuBtn.vue?vue&type=script&lang=js"
import style0 from "./MenuBtn.vue?vue&type=style&index=0&id=12c0ca8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c0ca8a",
  null
  
)

export default component.exports